module.exports = __webpack_public_path__ + "static/img/cyclist.5ccdf47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/intro/cyclist.svg
// module id = 71
// module chunks = 2